import { render } from "./myCadacBannerBlock.vue?vue&type=template&id=67f3ec1a&scoped=true&ts=true"
import script from "./myCadacBannerBlock.vue?vue&type=script&lang=ts"
export * from "./myCadacBannerBlock.vue?vue&type=script&lang=ts"

import "./myCadacBannerBlock.vue?vue&type=style&index=0&id=67f3ec1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f3ec1a"]])

export default __exports__